import React, { useState } from 'react';
import __ from 'localisation';
import Heading from 'components/Heading';
import { Columns, Column } from 'components/Columns';
import { getCurrency } from "helpers";
import Main from 'components/Main';
import InputCurrency from '@hubins/components/Input/Currency';
import Checkbox from 'components/Checkbox';
import Button from '@hubins/components/Button';
import Accordeon from 'components/Accordeon';
import DepositAndWithdrawalChart from 'components/Charts/ChartPie/DepositAndWithdrawalChart';
import DepositTable from 'modules/Tables/DepositTable';
import ErrorMessage from 'components/ErrorMessage';
import { currencyToNumber } from 'helpers';
import { validateNumber } from 'components/Validation';
import {
  depositChartData,
  getPremiumDropdownTableValues,
} from 'components/DropDownEffect/dropDownCalculator';

import middleman from 'helpers/middleman';


const Create = ({ transaction, setSelected, setTransaction, portfolio, portfolioUuid }) => {
  const [amount, setAmount] = useState({ value: transaction ? (transaction.amount / 100) : '', error: false });
  const [checkbox, setCheckbox] = useState({ value: false, error: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // useEffect(() => {
  //   if (transaction) {
  //     setAmount({ value: transaction.amount / 100, error: false });
  //   }
  // }, [transaction]);

  const submit = async () => {

    if (!amount.value) {
      setError('Vänligen fyll i ett belopp');
      return;
    }

    if (amount.error) {
      setError(amount.error);
      return;
    }

    if (!checkbox.value) {
      setError('Vänligen bekräfta Krav och Behovsprövnings bekräftelsen ovan för att gå vidare.');
      return;
    }

    if (!portfolio) {
      setError('Hitta ingen portfölj');
    }

    setError(false);
    setLoading(true);

    try {
      const value = currencyToNumber(amount.value);
      const request = transaction
        ? middleman.promisePost(`/transactions/update/${portfolioUuid}`, {
          id: transaction.uuid,
          amount: value,
          type: 'PRE'
        })
        : middleman.promisePost(`/transactions/create/${portfolioUuid}`, {
          amount: value,
          type: 'PRE'
        });
      const response = await request.then(res => res.data);
      setTransaction(response);
      setSelected((prevSelected) => prevSelected + 1);
    } catch (e) {
      setError(__('Något gick fel. Vänligen försök igen.'));
    }
    setLoading(false);
  };

  const tableData = portfolio ? getPremiumDropdownTableValues(portfolio.fees, amount.value) : false;

  return (
    <Main>
      <Columns>
        <Column s="12">
          <Heading size="3">
            Premieinsättning
          </Heading>
          <Heading size="4">
            Välj konto och belopp
          </Heading>
        </Column>
        <Column m="6" s="12">
          <InputCurrency
            className="s-bottom-m"
            value={amount.value}
            error={amount.error}
            min={1}
            label={__("trade_amount") + " " + getCurrency()}
            required
            callback={(value) => {
              setAmount({ value, error: validateNumber(value, true, 1) });
            }}
          />
          <Heading size="4" className="s-bottom-m">Krav- och Behovsprövning & Källa till kapital</Heading>
          <Checkbox
            className="s-bottom-l"
            label={__("demand_assesment_checkbox")}
            id="required_checbox"
            optionsState={{
              error: checkbox.error,
              value: checkbox.value
            }}
            required
            callback={(value, err) =>
              setCheckbox({ value, error: err })
            }
          />
          <Button
            onClick={submit}
            loading={loading}
            disabled={loading}
            className="withicon cta"
            size="large"
            icon="arrow right 1"
            iconColor='white'
          >
            Gå vidare
          </Button>
          <ErrorMessage text={error} showError={error} />
        </Column>
        <Column s="12">
          <Heading size="4" className="c-primary">
            Avgifter
          </Heading>
          <p>Hur påverkas kontantpremien av ett års försäkringsavgifter?</p>
          <DepositAndWithdrawalChart data={portfolio ? depositChartData(portfolio.fees, 100000) : []} />
          <Heading size="5" className="c-primary">
            Försäkringsavgifter
          </Heading>
          <DepositTable
            data={tableData ? tableData.insurance : []}
          />
          <Heading size="5" className="s-top-m c-primary">
            Skatter
          </Heading>
          <DepositTable
            data={tableData ? tableData.tax : []}
          />
        </Column>
        <Column s="12">
          <Heading className="c-primary" element="h3" size="4">FAQ</Heading>
        </Column>
        <Column m="6" l="6">
          <Accordeon label={__("faq_q1")}>
            <div className="section-padding-small">
              <p>{__("faq_a1")}</p>
            </div>
          </Accordeon>
        </Column>
        <Column m="6" l="6">
          <Accordeon label={__("deposit_disclaimer_title")}>
            <div className="section-padding-small">
              {__("deposit_disclaimer")}
            </div>
          </Accordeon>
        </Column>
      </Columns>
    </Main>
  );
};

export default Create;
